import arrow_back from "../../img/Arrow_Vector.svg";
import React from "react";
import styled from "@emotion/styled";

export const ArrowDown = ({ onClick, dataTestId }) => {
  return (
    <ArrowDownImage
      src={arrow_back}
      onClick={onClick}
      data-testid={dataTestId}
    />
  );
};

export const ArrowLeft = ({ onClick, dataTestId }) => {
  return (
    <ArrowLeftImage
      src={arrow_back}
      onClick={onClick}
      data-testid={dataTestId}
    />
  );
};

const ArrowDownImage = styled("img")`
  transform: rotate(-90deg);
  transition: transform 0.3s;
  cursor: pointer;
`;

const ArrowLeftImage = styled("img")`
  transform: rotate(0deg);
  transition: transform 0.3s;
  cursor: pointer;
`;
